import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

import style from "./style";

const MasonryCard = ({ image, text }) => {
  const useStyles = makeStyles(style);
  const classes = useStyles();
  return (
    <div data-aos="fade-in" data-aos-delay="100" className={`${classes.masonryCard}`}>
      <img src={image} alt="MasonryImage" className={classes.image} />
      <Typography variant="h6" gutterBottom className={classes.title}>
        {text}
      </Typography>
    </div>
  );
};

export default MasonryCard;
